import { IntlProvider } from 'react-intl';
import { decode } from 'html-entities';
import type { ReactNode } from 'react';

interface I18nProviderProps {
    children: ReactNode;
    locale: string;
    translations: { [key: string]: string };
}

export const I18nProvider = ({ children, locale, translations }: I18nProviderProps) => {
    shim(translations);
    return (
        <IntlProvider locale={locale} messages={translations}>
            {children}
        </IntlProvider>
    );
};

type I18nType = {
    __?: (translation: string) => string;
};

function shim(translations: { [key: string]: string }) {
    (function (self: I18nType) {
        if (typeof self.__ === 'undefined' || typeof window === 'undefined') {
            self.__ = (translation: string): string => {
                return decode(translations[translation]) || translation;
            };
        }
    })(typeof global !== 'undefined' ? global : typeof window !== 'undefined' ? window : this);
}
